export default "__VITE_ASSET__B4DpAm51__"